import { jsx } from "react/jsx-runtime";
import { Spinner } from "@wix/wix-ui-tpa/cssVars";
import { classes } from "./loader.st.css";
const Loader = () => /* @__PURE__ */ jsx("div", { className: classes.root, children: /* @__PURE__ */ jsx(Spinner, { className: classes.spinner }) });
export {
  Loader
};
//# sourceMappingURL=index.js.map
